import { SessionRelevantInfo } from '@tableau/workbook-templates-widgets/lib/src/components/template_item/TemplateDescription';
import { ServerService } from '../../ts/services/ServerService';

export function buildSessionRelevantInfo(serverService: ServerService): SessionRelevantInfo {
    return {
        oauthSettings: serverService.oauthSettings(),
        serverBuild: serverService.sessionServerVersion().build,
        serverVersion: serverService.sessionServerVersion().platform,
        langauge: serverService.sessionLanguage(),
    };
}